import { startApp } from '@horof/shared';
import dayjs from 'dayjs';
import 'dayjs/locale/ar-ma';
import { App } from './App';
import './desk.css';

// antd's date pickers: Moroccan month names (يناير… غشت… دجنبر, as on arqam's
// documents), Western digits, weeks from Saturday.
dayjs.locale('ar-ma');

// The treasurer writes the finances; the committee reads them (doc 30).
startApp({ allow: ['treasurer', 'committee'], App, density: 'desk' });
